import styled from 'styled-components';

export const Title = styled.div`
  text-align: right;
`;

export const Footer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: right;
  margin: 0 10px;
`;
